import React, { createContext, useState } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom'
import jwt_decode from "jwt-decode";

const Context = createContext();

function AuthProvider({children}){
    const [authenticated, setAuthenticated] = useState(!!JSON.parse(localStorage.getItem('token')));
    const [isFetchingLogin, setIsFetchingLogin] = useState(false);
    const [isFetchingCreateUser, setIsFetchingCreateUser] = useState(false);
    const [isFetchingRecoverPassword, setIsFetchingRecoverPassword] = useState(false);
    const [isFetchingCreateNewBook, setIsFetchingCreateNewBook] = useState(false);
    const [isFetchingEditUser, setIsFetchingEditUser] = useState(false);
    const [loginError, setLoginError] = useState({isError: false, message: ''});
    const [createError, setCreateError] = useState({isError: false, message: ''});

    const navigate = useNavigate();
    
    async function handleLogin(email, password){
        setIsFetchingLogin(true);
        setLoginError({ isError: false, message: ''})

        await api.post('/login', { email, password })
            .then(res => handleRequest(res.data.token))
            .catch(err => setLoginError({ isError: true, message:  err.response.data.msg}))
            .finally(() => setIsFetchingLogin(false));
    }

    async function handleCreateNewUser(name, email, password){
        setIsFetchingCreateUser(true);
        setCreateError({ isError: false, message: ''})
        
        await api.post('/users', { name, email, password })
            .then(res => handleLogin(email, password))
            .catch(err => setCreateError({ isError: true, message:  err.response.data.msg}))
            .finally(() => setIsFetchingCreateUser(false));
    }

    async function handleEditUser(name, email, password){
        setIsFetchingEditUser(true);
        setCreateError({ isError: false, message: ''});

        const token = JSON.parse(localStorage.getItem('token'));
        const { uso_id } = jwt_decode(token);

        let body = { name }

        if(password !== ''){
            body.password = password;
        }
        if(email !== ''){
            body.email = email;
        }
        
        await api.put(`/users/${uso_id}`, body, {
            headers: {
                'x-session-token': token,
            }
        })
            .then(res => navigate('/home'))
            .catch(err => setCreateError({ isError: true, message:  err.response.data.msg}))
            .finally(() => setIsFetchingEditUser(false));
    }

    async function handleRecoverPassword(email){
        setIsFetchingRecoverPassword(true);
        setCreateError({ isError: false, message: ''})

        await api.put('/users/reset-password', {email})
            .then(res => res)
            .catch(err => setCreateError({ isError: true, message:  err.response.data.msg}))
            .finally(() => setIsFetchingRecoverPassword(false));
    }
    

    async function handleCreateNewBook(title, author, pages, publisher, description, image){
        setIsFetchingCreateNewBook(true);
        setCreateError({ isError: false, message: ''})
        const selectedBook = {
            volumeInfo:{
                authors:[author],
                description,
                imageLinks:{
                    smallThumbnail:image
                },
                title,
                pageCount: pages,
                publisher
            }
        }
        navigate('/book', {state: selectedBook})
        setIsFetchingCreateNewBook(false);
    }

    const handleRequest = (token) => {
        localStorage.setItem('token', JSON.stringify(token));
        api.defaults.headers.Authorization = `Bearer ${token}`;
        const { uso_id } = jwt_decode(token);
        setAuthenticated(true);
        navigate('/home', {state: uso_id})
    };

    return(
        <Context.Provider value={{authenticated, handleLogin, handleCreateNewUser, handleRecoverPassword, handleEditUser, handleCreateNewBook, isFetchingLogin, isFetchingCreateUser, isFetchingRecoverPassword, isFetchingEditUser, isFetchingCreateNewBook, loginError, createError, setCreateError}}>
            {children}
        </Context.Provider>
    );
}

export { Context, AuthProvider };